window.addEventListener('load', function () {
    var evt = document.querySelector('.LandmarkBanner__title');
    var std = document.querySelector('.Event__start');
    var wdt = (704 - 32 - std.clientWidth) / 2;
    var wdp = Math.round(100 * wdt / 704);
    evt.setAttribute('style', '--width: ' + wdp + '%');
});
